import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';

import authSlice from './auth/authSlice';
import themeSlice from './theme/themeSlice';
import appStateSlice from './appState/appStateSlice';
import journeyMapSlice from './journeyMap/journeyMapSlice';
import offeringConfigurationSlice from './offeringConfiguration/offeringConfigurationSlice';
import missionSlice from './Mission/missionSlice';
import forumSlice from "./forum/forumSlice";
import solutionSlice from './Gallery/solutionSlice';
import notificationsSlice from './notification/notificationSlice';
import leaderboardSlice from './journeyMap/leaderboardSlice';

const reducers = combineReducers({
  auth: authSlice.reducer,
  theme: themeSlice.reducer,
  appState: appStateSlice.reducer,
  journeyMapSlice: journeyMapSlice.reducer,
  offeringConfiguration: offeringConfigurationSlice.reducer,
  mission: missionSlice.reducer,
  forum: forumSlice.reducer,
  solutions: solutionSlice.reducer,
  notifications: notificationsSlice.reducer,
  leaderboardSlice: leaderboardSlice.reducer
});

const rootReducer = (state, action) => {
  if (action.type === "resetStore") {
    storage.removeItem('persist:root');
    state = undefined;
  }
  return reducers(state, action);
};
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ["theme", "auth", "appState"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});


store.reset = () => {
  store.dispatch({ type: "resetStore" });
};

export default store;